var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXCircleSolidCurrentColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.142 5.224A9.7 9.7 0 1 1 18.86 18.942 9.7 9.7 0 0 1 5.142 5.224m3.364 3.364a.7.7 0 0 1 .99 0L12 11.093l2.505-2.505a.7.7 0 0 1 .99.99l-2.505 2.505 2.505 2.505a.7.7 0 0 1-.99.99L12 13.073l-2.505 2.505a.7.7 0 0 1-.99-.99l2.505-2.505-2.505-2.505a.7.7 0 0 1 0-.99",
  clipRule: "evenodd"
})));
export default SvgXCircleSolidCurrentColor;